import { action } from "mobx";
import fetchBrandsList from "./service";
import { sortArrayOfStrings, getBrandsListFromFiltersAPI } from "../../utils";

class StoreLocatorStoreActions {
  @action
  fetchBrands() {
    return fetchBrandsList().then(
      action(response => {
        this.brandsList = sortArrayOfStrings(
          getBrandsListFromFiltersAPI(response),
        );
      }),
    );
  }
}

export default StoreLocatorStoreActions;



// WEBPACK FOOTER //
// ./src/stores/StoreLocatorStore/actions.js